import "./Menu.css";
import { Link, useLocation } from "react-router-dom";

function Menu({ loggedIn, isDark, setIsDark, onLogout }) {
  const location = useLocation();
  console.log(window.location.pathname);

  const changeTheme = () => {
    console.log("theme change");
    setIsDark(!isDark);
  };

  const handleLogout = () => {
    onLogout();
  };

  return (
    <nav className='navigation'>
      <ul className='navigation__list'>
        {/* <li className='navigation__list-item'>
          <Link className={location.pathname === "/" ? "active" : ""} to='/'>
            Home
          </Link>
        </li> */}
        <li className='navigation__list-item'>
          <Link
            className={location.pathname === "/memarts" ? "active" : ""}
            to='/memarts'
          >
            MemArts
          </Link>
        </li>
        {/* <li className='navigation__list-item'>
          <Link
            className={location.pathname === "/namethings" ? "active" : ""}
            to='/namethings'
          >
            Name 3 things
          </Link>
        </li>
        <li className='navigation__list-item'>
          <Link
            className={location.pathname === "/favs" ? "active" : ""}
            to='/favs'
          >
            Your favourites
          </Link>
        </li> */}
        <li className='navigation__list-item'>
          <Link
            className={location.pathname === "/guess" ? "active" : ""}
            to='/guess'
          >
            Guessing game
          </Link>
        </li>
        <li className='navigation__list-item'>
          <Link
            className={location.pathname === "/hangman" ? "active" : ""}
            to='/hangman'
          >
            Hangman
          </Link>
        </li>
        {loggedIn && (
          <li className='navigation__list-item'>
            <Link
              className={location.pathname === "/phonetics" ? "active" : ""}
              to='/phonetics'
            >
              Phonetics
            </Link>
          </li>
        )}
        {/* <li className='navigation__list-item'>
          <Link
            className={location.pathname === "/puzzles" ? "active" : ""}
            to='/puzzles'
          >
            Puzzles
          </Link>
        </li> */}
        <li className='navigation__list-item auth-buttons'>
          {!loggedIn ? (
            <>
              <Link to='/login' className='auth-btn login-btn'>
                Login
              </Link>
              <Link to='/register' className='auth-btn register-btn'>
                Register
              </Link>
            </>
          ) : (
            <>
              <Link to='/dashboard' className='auth-btn login-btn'>
                Dashboard
              </Link>
              <button
                className='auth-btn'
                onClick={handleLogout}
                aria-label='Logout'
              >
                Log out
              </button>
            </>
          )}
        </li>
        {/* <li className='navigation__list-item theme-btn-wrapper'>

        </li> */}
        <li className='navigation__list-item theme-btn-wrapper'>
          <button
            className='theme-btn'
            onClick={changeTheme}
            aria-label='Switch theme'
          >
            {isDark ? "🌙" : "☀️"}
          </button>
        </li>
      </ul>
    </nav>
  );
}

export default Menu;
